import { render, staticRenderFns } from "./SurveyModifyQuestionOriginalAnswer.vue?vue&type=template&id=4f0f0490&scoped=true&"
import script from "./SurveyModifyQuestionOriginalAnswer.vue?vue&type=script&lang=js&"
export * from "./SurveyModifyQuestionOriginalAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SurveyModifyQuestionOriginalAnswer.vue?vue&type=style&index=0&id=4f0f0490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f0490",
  null
  
)

export default component.exports